import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {traceAction} from "../../enum/traceAction";

export const TraceActionSelector = ({label, onChange}) => {
    return (
        <Autocomplete
            sx={{mb: 1, mt: 1}}
            options={[
                {id: traceAction.created, label: 'Created'},
                {id: traceAction.transferred, label: 'Transferred'},
                {id: traceAction.frozen, label: 'Frozen'},
                {id: traceAction.burnt, label: 'Burnt'},
                {id: traceAction.lotDestroyed, label: 'Destroyed'},
                {id: traceAction.thawed, label: 'Thawed'},
                {id: traceAction.reboxed, label: 'Reboxed'},
            ]}
            fullWidth
            variant="outlined"
            size="small"
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(event, action) => onChange(action?.id || null)}
            getOptionLabel={status => status?.label}
            renderInput={params => <TextField {...params} variant="standard" label={label} required/>}
        />
    );
};
